import { takeLatest } from 'redux-saga/effects';
import {
  getLeaveCreditForecastListSuccess, getLeaveCreditForecastListFail,
  getLeaveCreditForecastDetailsSuccess, getLeaveCreditForecastDetailsFail,
} from './leaveCreditForecastState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/timekeeping/leave-credit-forecasts');
const modelName = 'LeaveCreditForecast';
const modelId = 'lcf_id';

function* getLeaveCreditForecastList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getLeaveCreditForecastListSuccess, 
		getLeaveCreditForecastListFail, null, null, LOADING_MSG);
}

function* getLeaveCreditForecastDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getLeaveCreditForecastDetailsSuccess, 
		getLeaveCreditForecastDetailsFail, null, null, LOADING_MSG);		
}

function* leaveCreditForecastSaga() {
	yield takeLatest('leaveCreditForecast/getLeaveCreditForecastList', getLeaveCreditForecastList);
	yield takeLatest('leaveCreditForecast/getLeaveCreditForecastDetails', getLeaveCreditForecastDetails);
}

export default leaveCreditForecastSaga;
